import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	setStopListSyncIntervalMinutes: (value: Nullable<number>) => void;
}

export const StopListSyncIntervalField: React.FC<IProps> = React.memo(({ setStopListSyncIntervalMinutes }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterStopListSyncInterval') }], [t]);

	return (
		<FormInputNew
			testId="StopListSyncIntervalField"
			type="number"
			min={5}
			max={600}
			precision={0}
			name="stopListSyncIntervalMinutes"
			label="stopListSyncIntervalLabel"
			placeholder="stopListSyncIntervalPlaceholder"
			validationRules={validationRules}
			onChangeNumber={setStopListSyncIntervalMinutes}
		/>
	);
});
